import React, { useState, useEffect } from "react";

const SearchFilterWithButton = ({
  selectedSearch,
  setSelectedSearch,
  onSearch,
}) => {
  const [inputValue, setInputValue] = useState(selectedSearch);
  const [isSearchActive, setIsSearchActive] = useState(false);

  // Update local state when selectedSearch changes (like on reset)
  useEffect(() => {
    setInputValue(selectedSearch);
    setIsSearchActive(false);
  }, [selectedSearch]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setIsSearchActive(false);
  };

  const handleSearch = () => {
    setIsSearchActive(true);
    // Call both functions together to ensure synchronous execution
    setSelectedSearch(inputValue);
    onSearch(inputValue); // Pass the current input value directly to search
  };

  return (
    <div
      className={`timesheet_dropdown_wrapper ${
        selectedSearch ? "has-selection" : ""
      }`}
      style={{ display: "flex", gap: "10px", alignItems: "center" }}
    >
      <input
        type="search"
        value={inputValue}
        placeholder="Search..."
        onChange={handleInputChange}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            handleSearch();
          }
        }}
        className={`commonWrapper ${selectedSearch ? "has-value" : ""}`}
        style={{
          border: isSearchActive ? "1px solid #28a745" : "1px solid #dee2e6",
          borderRadius: "4px",
          padding: "8px 12px",
          width: "100%",
          outline: "none",
          transition: "border-color 0.2s ease",
        }}
      />
      <button
        onClick={handleSearch}
        className="btn btn-primary"
        style={{
          padding: "8px 16px",
          borderRadius: "4px",
          border: "none",
          cursor: "pointer",
          backgroundColor: "#dc3545",
          color: "white",
          height: "49px",
        }}
      >
        Search
      </button>
    </div>
  );
};

export default SearchFilterWithButton;
